import { render, staticRenderFns } from "./LabLegado.vue?vue&type=template&id=d9b6d778&"
import script from "./LabLegado.vue?vue&type=script&lang=js&"
export * from "./LabLegado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports